export default {
  translation: {
    jsonEditor: 'JSON编辑器',
    format: '格式化',
    compress: '压缩',
    copy: '复制',
    clear: '清除',
    copied: '已复制！',
    copyFailed: '复制失败',
    enterJson: '在此输入JSON...',
    enterSearchText: '输入要查找的内容，按回车搜索...',
    pleaseEnterJson: '请输入 JSON 内容',
    invalidJson: '无效的 JSON 格式',
    jsonFormatter: 'JSON',
    textProcessor: '文本处理',
    sqlFormatter: 'SQL',
    settings: '设置',
    language: '语言',
    pleaseEnterSQL: '请输入SQL语句',
    invalidSQL: '无效的SQL语句',
    formatFailed: '格式化失败',
    compressFailed: '压缩失败',
    enterSQLHere: '在此输入 SQL...',
    pleaseEnterText: '请输入文本内容',
    textSplit: '请选择分隔符模式并输入分隔符',
    textProcessor: '文本处理',
    pleaseEnterAddChar: '输入要添加的字符',
    row_header: '行首',
    row_tail: '行尾',
    row_split: '行分割',
    pleaseEnterMultiText: '在此输入多行文本',
    row_asc: '升序',
    row_desc: '降序',
    row_add: '添加',
    row_cut: '去除',
    row_lineBreak: '换行',
    about: '关于',
    aboutDescription: '这是一个 React Tools应用。如有任何问题, 欢迎联系我。',
    myEmail: 'pengchangchengde@gmail.com',
    qrCode: '二维码',
    qrCodeGenerator: '二维码生成器',
    enterQrContent: '输入要生成二维码的内容',
    size: '大小',
    foregroundColor: '前景色',
    backgroundColor: '背景色',
    errorCorrectionLevel: '纠错级别',
    low: '低',
    medium: '中',
    quartile: '较高',
    high: '高',
    downloadQrCode: '下载二维码',
  }
};